<script>
  import { onMount } from "svelte";
  import axios from "axios";
  import { link } from "svelte-spa-router";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import Select from "svelte-select";
  import { Circle } from "svelte-loading-spinners";
  import * as ls from "local-storage";

  export let params;
  let uploading = false;
  let loading = true;

  let name = null;
  let price = null;
  let inventoryLevel = null;
  let reorderLevel = null;
  let supplierID = null;
  let SKU = null;
  let rowN = null;
  let colour = null;
  let description = null;

  //
  let supplier;

  onMount(() => {
    axios
      .get(`${$config.backendURL}/items/${params.id}`)
      .then((res) => {
        name = res.data.name;
        price = res.data.price;
        inventoryLevel = res.data.inventoryLevel;
        reorderLevel = res.data.reorderLevel;
        supplierID = res.data.supplierID;
        SKU = res.data.SKU;
        rowN = res.data.rowN;
        colour = res.data.colour;
        description = res.data.description;
        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  });

  const handleClear = () => {
    name = null;
    price = null;
    inventoryLevel = null;
    reorderLevel = null;
    SKU = null;
    rowN = null;
    colour = null;
    description = null;
  };

  const handleSubmit = async (e) => {
    if (!name) alert("Item Name Missing");
    else if (!price) alert("Price missing!");
    else if (inventoryLevel == undefined) alert("Inventory Level missing!");
    else if (reorderLevel == undefined) alert("Reorder Level missing!");
    else if (!supplierID) alert("Supplier missing!");
    else if (!SKU) alert("SKU missing!");
    else if (!colour) alert("Colour missing!");
    else {
      uploading = true;

      let data = {
        name,
        price,
        inventoryLevel,
        reorderLevel,
        supplierID: supplier?.value || supplierID,
        SKU,
        rowN,
        colour,
        description,
      };

      axios
        .put(`${$config.backendURL}/items/${params.id}`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Updated Successfully`);
          window.location.reload();
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };
</script>

<svelte:head>
  <title>Edit Stock Item | Fabi CC System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Edit Item"
    description="Fill out the form below to edit items. All fields are REQUIRED."
  />

  <div class="flex justify-end mb-6">
    <a class="ml-3 btn btn-green-outline" href="/#home">
      <i class="fas fa-arrow-left mr-3" />
      Return to Stock
    </a>
  </div>

  {#if loading}
    <div class="h-52 w-full flex items-center justify-center">
      <Circle size="50" color="rgb(16, 185, 129)" unit="px" />
    </div>
  {:else}
    <form
      on:submit|preventDefault={handleSubmit}
      class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
    >
      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Item Name :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={name}
            placeholder="Stock Item Name"
            required
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Unit Price :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={price}
            placeholder="Unit Price"
            required
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Inventory Level :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={inventoryLevel}
            placeholder="Inventory Level"
            required
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>EOQ :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={reorderLevel}
            placeholder="EOQ"
            required
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Current Supplier</div>
          <div class="col-span-2">
            {$config.suppliers.find(({ value }) => value == supplierID).label}
          </div>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Change Supplier</div>
          <div class="col-span-2">
            <Select
              items={$config.suppliers}
              on:select={(e) => (supplier = e.detail)}
            />
          </div>
        </div>

        <div class="grid grid-cols-3 gap-2 items-center">
          <div>SKU :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={SKU}
            placeholder="SKU"
            required
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Roll Number [Optional] :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={rowN}
            placeholder="Roll Number"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Colour :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={colour}
            placeholder="Colour"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Description :</div>
          <textarea
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={description}
            placeholder="Stock Unit Description"
            rows="2"
          />
        </div>
      </div>

      {#if uploading}
        <div class="grid grid-cols-1 gap-8">
          <div class="flex items-center justify-center btn btn-green-outline">
            <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
            <span class="ml-4">Please wait...</span>
          </div>
        </div>
      {:else}
        <!-- else content here -->
        <div class="grid grid-cols-2 gap-8">
          <button class="btn btn-green-outline" on:click={handleClear}>
            <i class="fas fa-times-circle mr-3" />
            Clear Form
          </button>
          <button class="btn btn-green">
            <i class="fas fa-check-circle mr-3" />
            Save to Database
          </button>
        </div>
      {/if}
    </form>
  {/if}
</Layout>
